import Checkbox from '@mui/material/Checkbox';
import Grid from '@mui/material/Grid';
import Icon from '@mui/material/Icon';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';

import CheckCircle from '@mui/icons-material/CheckCircle';
import Edit from '@mui/icons-material/Edit';
import Image from '@mui/icons-material/Image';
import AttachMoney from '@mui/icons-material/AttachMoney';
import CreditScore from '@mui/icons-material/CreditScore';
import PendingActions from '@mui/icons-material/PendingActions';
import PriceCheck from '@mui/icons-material/PriceCheck';
import VolunteerActivism from '@mui/icons-material/VolunteerActivism';

import { memo } from 'react';

// MARK: Show Item
export const ItemShow = memo(({ item, checked, onEditItem, onCheckboxChange }) => {
    const handleEditItem = () => {
        onEditItem();
    };

    const handleCheckboxChange = (e) => {
        onCheckboxChange(item, e.target.checked);
    };

    return (
        <Grid container alignItems="center" sx={ { width: '100%', px: 1 } } spacing={ 1 }>
            <Grid size={ { xs: 1 } } sx={ { px: 0 } } display='flex' justifyContent='center' alignItems='center' >
                <Checkbox
                    name={ `${ item.id }` }
                    checked={ checked }
                    onChange={ handleCheckboxChange }
                    aria-label={ `Select item ${ item.name }` }
                />
            </Grid>

            <Grid size={ { xs: 4, sm: 2 } } sx={ { px: 1 } } >
                <Tooltip title={ item.name }>
                    <Typography noWrap>
                        { item.name }
                    </Typography>
                </Tooltip>
            </Grid>

            <Grid size={ { xs: 2 } } display={ { xs: 'none', sm: 'flex' } } sx={ { px: 1 } } >
                <Tooltip title={ item.price ? `$${ Number(item.price).toFixed(2) }` : '$0.00' }>
                    <Typography noWrap>
                        { item.price ? `$${ Number(item.price).toFixed(2) }` : '$0.00' }
                    </Typography>
                </Tooltip>
            </Grid>

            <Grid size={ { xs: 1 } } textAlign="center" >
                <Tooltip title={ item.sold ? 'Item Sold' : 'Item Not Sold' }>
                    <AttachMoney
                        color={ item.sold ? 'success' : 'disabled' }
                        aria-label="item sold"
                        sx={ { fontSize: { xs: 16, sm: 24 } } }
                    />
                </Tooltip>
            </Grid>

            <Grid size={ { xs: 1 } } textAlign="center" >
                <Tooltip title={ item.image ? 'Item Has Image' : 'No Image Provided' }>
                    <Image
                        color={ item.image ? 'secondary' : 'disabled' }
                        aria-label="item image"
                        sx={ { fontSize: { xs: 16, sm: 24 } } }
                        src={ item.imageUrl }
                    />
                </Tooltip>
            </Grid>

            <Grid size={ { xs: 1 } } textAlign="center" >
                <Tooltip title={ item.donation ? 'Proceeds donated' : 'No proceeds donated' }>
                    <VolunteerActivism
                        color={ item.donation ? 'secondary' : 'disabled' }
                        aria-label="item donation"
                        sx={ { fontSize: { xs: 16, sm: 24 } } }
                    />
                </Tooltip>
            </Grid>

            <Grid size={ { xs: 1 } } textAlign="center" >
                <Tooltip title={ item.payoutStatus === 'paid' ? `Paid out: $${ item.payoutAmount.toFixed(2) || '$0.00' }` : "Item not paid out" }>
                    <PriceCheck
                        color={ item.payoutStatus === 'paid' ? 'success' : 'disabled' }
                        aria-label="verified"
                        sx={ { fontSize: { xs: 16, sm: 24 } } }
                    />
                </Tooltip>
            </Grid>

            <Grid size={ { xs: 1 } } textAlign="center" >
                <Tooltip title={ item.feePaid ? "Listing fee paid" : "Payment pending" }>
                    <Icon color={ item.feePaid ? 'success' : 'warning' } aria-label="fee paid" sx={ { fontSize: { xs: 16, sm: 24 } } }>
                        { item.feePaid ? <CreditScore fontSize="inherit" /> : <PendingActions fontSize="inherit" /> }
                    </Icon>
                </Tooltip>
            </Grid>

            <Grid size={ { xs: 1 } } textAlign="center" >
                <Tooltip title={ item.verified ? "Item verified" : "Item not verified" }>
                    <Icon color={ item.verified ? 'success' : 'disabled' } aria-label="verified" sx={ { fontSize: { xs: 16, sm: 24 } } }>
                        <CheckCircle fontSize="inherit" />
                    </Icon>
                </Tooltip>
            </Grid>

            <Grid size={ { xs: 1 } } textAlign="center" >
                <IconButton onClick={ handleEditItem } aria-label="edit" sx={ { fontSize: { xs: 16, sm: 24 } } }>
                    <Edit fontSize="inherit" />
                </IconButton>
            </Grid>
        </Grid>
    )
});

ItemShow.displayName = 'Show Item';